import { useMemo } from "react";
import usePaginatedApiData from "../../../hooks/usePaginatedApiData";
import { buildPaginationParams } from "../../../utils/pagination";

export default function useMembershipSponsorshipsData({
  page,
  pageSize,
  searchTerm,
  filters,
  orderBy,
  orderDirection,
}) {
  const params = useMemo(
    () =>
      buildPaginationParams({
        page,
        pageSize,
        search: searchTerm || undefined,
        status: filters?.status || undefined,
        sponsorship_type: filters?.sponsorship_type || undefined,
        sponsorship_level: filters?.sponsorship_level || undefined,
        program_area: filters?.program_area || undefined,
        sort_by: orderBy,
        sort_dir: orderDirection,
      }),
    [page, pageSize, searchTerm, filters?.status, filters?.sponsorship_type, filters?.sponsorship_level, filters?.program_area, orderBy, orderDirection],
  );

  const { data, totalCount, loading, error, refetch } = usePaginatedApiData({
    endpoint: "/membership/sponsorships",
    params,
    errorMessage: "Failed to load sponsorships",
  });

  return { sponsorships: data, totalCount, loading, error, refetch };
}
